import {accountHasFeature, userHasPermission} from 'helpers/user'
import {features, permissions} from 'helpers/constants'
import {get, isNil} from 'lodash'
import {openUrlInNewTab} from 'helpers/url'

export const isHubspotEnabled = (user) => {
  return (
      accountHasFeature(user, features.HUBSPOT_SYNC)
  )
}

export const isPostToHubspotEnabled = (user, isHubspotConnected) => {
  return (
      isHubspotConnected &&
      isHubspotEnabled(user) &&
      userHasPermission(user, permissions.POST_CONTACTS)
  )
}

export const HubspotMergeFieldTag = {
  ADDRESS: 'address',
  BUSINESS_TYPE: 'business_type',
  COMPANY_NAME: 'company_name',
  GROUPS: 'contact_groups',
  EMPLOYEES: 'company_employees',
  FIRSTNAME: 'forename',
  INDUSTRY: 'industry',
  JOB_TITLE: 'jobtitle',
  NUMBER_OF_EMPLOYEES: 'numemployees',
  PHONE: 'phone',
  SALUTATION: 'salutation',
  SURNAME: 'surname',
  WORK_EMAIL: 'work_email',
}

export const getHubSpotContactId = (contact) => {
  return get(contact, 'hubspotContactMapping.vid', null)
}

export const getHubSpotDealId = (opportunity) => {
  return get(opportunity, 'hubspotDealMapping.dealId', null)
}

export const getHubSpotContactDeepLinkUrl = (portalId, vid) => {
  return `https://app.hubspot.com/contacts/${portalId}/contact/${vid}/`
}

export const viewContactInHubSpot = (hubspotStatus, contact, onShowPrompt, onHideMenu) => {
  const portalId = get(hubspotStatus, 'portalId', null)
  const hubSpotContactId = getHubSpotContactId(contact)

  onHideMenu()

  if (isNil(hubSpotContactId)) {
    onShowPrompt(
        'View Contact in HubSpot',
        'We could not find a matching contact in HubSpot. Please ensure that this contact has been posted to Hubspot from Clarity Go'
    )
    return
  }

  openUrlInNewTab(getHubSpotContactDeepLinkUrl(portalId, hubSpotContactId))
}

export const getHubSpotDealDeepLinkUrl = (portalId, dealId) => {
  return `https://app.hubspot.com/contacts/${portalId}/deal/${dealId}`
}

export const viewOpportunityInHubSpot = (hubspotStatus, opportunity, onShowPrompt, onHideMenu) => {
  const portalId = get(hubspotStatus, 'portalId', null)
  const hubspotDealId = getHubSpotDealId(opportunity)

  onHideMenu()

  if (isNil(hubspotDealId)) {
    onShowPrompt(
        'View Opportunity in HubSpot',
        'We could not find a matching opportunity in HubSpot.'
    )
    return
  }

  openUrlInNewTab(getHubSpotDealDeepLinkUrl(portalId, hubspotDealId))
}
